import AccountsMenu from "./AccountsMenu";
import { Bell } from "lucide-react";
import { useState, useEffect } from "react";
import { useAuth, useUser } from "@clerk/clerk-react";
import axios from "axios";
import { api_endpoint } from "../constants/constant";
import { useNavigate } from "@tanstack/react-router";

const Topbar = () => {
  const [unreadCount, setUnreadCount] = useState(0);
  const { getToken } = useAuth();
  const { user } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUnreadCount = async () => {
      if (!user) return;
      try {
        const token = await getToken();
        if (!token) return;
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };
        const response = await axios.get(
          `${api_endpoint}/notification/user-notifications`,
          config
        );
        const notifications = response.data.notifications || [];
        const unread = notifications.filter((n) => !n.is_read).length;
        setUnreadCount(unread);
      } catch (error) {
        setUnreadCount(0);
      }
    };
    fetchUnreadCount();
  }, [user, getToken]);

  return (
    <div className="sticky top-0 z-40 flex h-[65px] w-full min-w-0 items-center justify-between border-b border-(--neutral-300) bg-(--surface-base) px-4 md:px-6 text-(--neutral-900)">
      {/* Left: Logo and title */}
      <div className="flex items-center gap-2">
        <div className="flex flex-col">
          <span className="font-heading text-lg font-semibold text-(--neutral-900)">Zindua LMS</span>
        </div>
      </div>
      {/* Right: Notification bell and accounts menu horizontally aligned */}
      <div className="flex flex-row items-center gap-3">
        <button
          type="button"
          aria-label="Open notifications"
          className="relative flex h-10 w-10 items-center justify-center bg-(--surface-base) text-(--neutral-600) transition hover:border-(--neutral-300) hover:text-(--neutral-900)"
          onClick={() => navigate({ to: "/notifications" })}
        >
          <Bell className="h-5 w-5" />
          {unreadCount > 0 && (
            <span className="absolute top-2 right-2 h-2 w-2 rounded-full bg-(--color-primary)" />
          )}
        </button>
        <div className="flex items-center h-10 -mt-2">
          <AccountsMenu showName={false} />
        </div>
      </div>
    </div>
  );
};

export default Topbar;